// Centralised content & imagery for Hoofs and Hides
export const BRAND = {
    name: "Hoofs and Hides",
    tagline: "Thirty years of masterful leather craftsmanship, tailored to your style.",
    phone: "+91 99454 01275",
    whatsapp: "919945401275",
    email: "salman@hoofsandhides.in",
    address: {
        line1: "No. 136, Wheeler Rd,",
        line2: "Sindhi Colony, Frazer Town,",
        line3: "Bengaluru, Karnataka 560005",
    },
    mapUrl:
        "https://www.google.com/maps/place/Hoofs+And+Hides/@12.9951167,77.6137266,17z/data=!3m1!4b1!4m6!3m5!1s0x3bae16f3b14e6cc3:0x5286f745fe257592!8m2!3d12.9951115!4d77.6163015!16s%2Fg%2F11hd_gyf9v?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D",
    hours: {
        weekdays: "Mon – Sat · 10:30 – 20:30",
        sunday: "Sunday · By appointment",
    },
    founded: 1992,
};

export const IMAGES = {
    heroMacro:
        "/brand/hero-edit.png",
    jacket:
        "https://static.prod-images.emergentagent.com/jobs/1c923f23-2c15-4159-9afc-ca7f9e478811/images/cd8cce0beede6e86e09540878a9ecf3ceb442a6fd3a9598289c96ce86f4b89af.png",
    shoes:
        "https://static.prod-images.emergentagent.com/jobs/1c923f23-2c15-4159-9afc-ca7f9e478811/images/ddacdb9a6e3543153fd1db0d82bdc3779b812f06dffeb50f69d766876840a52c.png",
    bag: "https://images.pexels.com/photos/26736142/pexels-photo-26736142.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
    walletBelt:
        "https://images.pexels.com/photos/302854/pexels-photo-302854.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
    storeInterior:
        "https://static.prod-images.emergentagent.com/jobs/1c923f23-2c15-4159-9afc-ca7f9e478811/images/2d909f5a42a289c1ab563b2c4d1879c25c50f79e4ff85d90e2c8e442c94df9ea.png",
    moodFashion1:
        "https://images.pexels.com/photos/31305929/pexels-photo-31305929.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
    moodFashion2:
        "https://images.pexels.com/photos/2345236/pexels-photo-2345236.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940",
    artisan:
        "https://images.unsplash.com/photo-1624241591008-de859ecb2945?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxibGFjayUyMGFuZCUyMHdoaXRlJTIwbGVhdGhlciUyMGJlbHQlMjBhbmQlMjB3YWxsZXR8ZW58MHx8fHwxNzc2ODUwMzM0fDA&ixlib=rb-4.1.0&q=85",
    belt:
        "brand/belt.jpg",
    wallet:
        "brand/wallet.jpg",
};

export const CATEGORIES = [
    {
        slug: "footwear",
        title: "Footwear",
        sub: "Formal · Casual · Sandals",
        count: "28 silhouettes",
        image: IMAGES.shoes,
        custom: true,
        description:
            "Hand-lasted shoes in full-grain calf and buffalo hide. Oxfords, derbies, loafers, sandals — each pair finished in-house.",
    },
    {
        slug: "jackets",
        title: "Jackets",
        sub: "Bespoke · Ready-to-wear",
        count: "14 cuts",
        image: IMAGES.jacket,
        custom: true,
        description:
            "Moto, bomber and tailored blazers cut from Italian and Spanish leathers. Custom patterns drafted to your measurements.",
    },
    {
        slug: "bags",
        title: "Bags",
        sub: "Totes · Weekenders · Briefs",
        count: "22 pieces",
        image: IMAGES.bag,
        custom: true,
        description:
            "Saddle-stitched and edge-painted by hand. Designed to outlast trends and carry the marks of your years.",
    },
    {
        slug: "belts",
        title: "Belts",
        sub: "Dress · Casual · Western",
        count: "36 buckles",
        image: IMAGES.belt,
        custom: true,
        description:
            "Single-layer vegetable-tanned belts that darken beautifully with age. Solid brass and matte nickel buckles.",
    },
    {
        slug: "wallets",
        title: "Wallets",
        sub: "Bifold · Cardholder · Long",
        count: "18 makes",
        image: IMAGES.wallet,
        custom: false,
        description:
            "Compact companions sewn in single-piece leather. Lined, unlined, and skeleton cuts — initialised on request.",
    },
];

export const FEATURES = [
    {
        index: "01",
        title: "Three decades of hands.",
        text: "Since 1992, the same atelier, the same obsession. Every piece passes through fewer than five pairs of trusted hands.",
    },
    {
        index: "02",
        title: "Full-grain, nothing less.",
        text: "We source only the top layer of the hide — the strongest, most character-rich part of the leather. It ages, it doesn't wear out.",
    },
    {
        index: "03",
        title: "Measured to you.",
        text: "Shoes and jackets are drafted from your body and your brief. A quiet fitting, a conversation, and a garment made once.",
    },
    {
        index: "04",
        title: "A lifetime, serviced.",
        text: "Re-soling, re-stitching, re-finishing. We keep your pieces alive long after purchase — because real leather deserves it.",
    },
];

export const TESTIMONIALS = [
    {
        quote:
            "Fromt the first step in, thsese shoes made me feel confident. The shine, the comfort, the craftsmanship - every details speaks of true luxury.",
        name: "Mohammed Farooq",
        role: "Chartered Accountant · Bengaluru",
    },
    {
        quote:
            "I walked in for a belt and walked out with a pair of oxfords drafted to my foot. Five years on, they're still the first shoes I reach for.",
        name: "Arjun Menon",
        role: "Architect · Bengaluru",
    },
    {
        quote:
            "The jacket they made me is the one my father will inherit. That should tell you everything.",
        name: "Ishaan Rao",
        role: "Musician · Mumbai",
    },
];

export const MOODBOARD = [
    { src: IMAGES.moodFashion1, h: "tall" },
    { src: IMAGES.heroMacro, h: "short" },
    { src: IMAGES.artisan, h: "medium" },
    { src: IMAGES.jacket, h: "tall" },
    { src: IMAGES.bag, h: "medium" },
    { src: "brand/WhatsApp Image 2026-04-28 at 15.57.37.jpeg", h: "tall" },
    { src: IMAGES.belt, h: "short" },
    { src: IMAGES.shoes, h: "medium" },
    { src: IMAGES.wallet, h: "short" },
];
